export default "__VITE_ASSET__R$dsfwMy__";